import UserPage from "flarum/forum/components/UserPage";
import Link from "flarum/components/Link";
/* global m */

const compareNames = (a, b) => {
  var nameA = a.name.toUpperCase(); // ignore upper and lowercase
  var nameB = b.name.toUpperCase(); // ignore upper and lowercase
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }

  // names must be equal
  return 0;
};
const compareAnswers = (a, b) => {
  return b.postsPerTag - a.postsPerTag;
};

export default class PersonalSubscriptionsPane extends UserPage {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = true;

    this.fields = [];
    this.answers = {};

    this.loadUser(m.route.param("id"));
  }

  content() {
    return m(".Professional-Achievemens", [
      m(
        ".Fields",
        this.fields
          .sort(compareAnswers)
          .map(
            ({ name, color, icon, slug, discussionsPerTag, subscriptionsCount }) => {
              return (
                <div
                  className="professional-achievemens-tag-item Mozaic-thriple"
                  style={"--tag-color:" + color}
                >
                  <div className="professional-achievemens-tag-desc">
                    <Link href={"/t/" + slug}>
                      <i className={icon} />
                      <span>{name}</span>
                    </Link>
                  </div>
                  <div className="proessional-achievements-tag-stats">
                    <span className="questions">
                      {"Вопросов задано:"}
                      {discussionsPerTag}
                    </span>
                    <span className="answers">
                      {"Подписчиков:"}
                      {subscriptionsCount}
                    </span>
                  </div>
                </div>
              );
            }
          )
      ),
    ]);
  }

  load(user) {
    app
      .request({
        method: "GET",
        url:
          app.forum.attribute("apiUrl") +
          "/personal_subscriptions/" +
          user.id(),
      })
      .then(this.parseResponse.bind(this));
  }

  show(user) {
    this.load(user);

    super.show(user);
  }

  parseResponse({ jsonapi }) {
    this.answers = {};
    this.fields = jsonapi.subscriptions;

    this.loading = false;
    // m.redraw();
  }
}
